import LinkEl from '@/components/elements/LinkEl.vue'
import Item2ColEl from '@/components/elements/Item2ColEl.vue'
import LineEl from '@/components/elements/LineEl.vue'
import TitleEl from '@/components/elements/TitleEl.vue'
import TextEl from '@/components/elements/TextEl.vue'
import ButtonEl from '@/components/elements/ButtonEl.vue'
import ProgressBarEl from '@/components/elements/ProgressBarEl.vue'
import BarEl from '@/components/elements/BarEl.vue'
import TelenorForYouEl from '@/components/elements/TelenorForYouEl.vue'
import AccountBalanceMoneyEl from '@/components/elements/AccountBalanceMoneyEl.vue'
import AccountBalanceStateEl from '@/components/elements/AccountBalanceStateEl.vue'
import CarouselEl from '@/components/elements/CarouselEl.vue'
import AccountBalanceDetailsEl from '@/components/elements/accountBalanceDetails/AccountBalanceDetailsEl.vue'
import SmallRowOfferEl from '@/components/elements/SmallRowOfferEl.vue'
import WhiteButtonEl from '@/components/elements/WhiteButtonEl.vue'
import ImageEl from '@/components/elements/ImageEl.vue'
import SmallAddOnEl from '@/components/elements/SmallAddOnEl.vue'
import SmallMultiRowOfferEl from '@/components/elements/SmallMultiRowOfferEl.vue'
import AddOnStatusEl from '@/components/elements/AddOnStatusEl.vue'
import SmallMonthlyInvoiceEl from '@/components/elements/SmallMonthlyInvoiceEl.vue'
import CheckboxEl from '@/components/elements/CheckboxEl.vue'
import DropdownEl from '@/components/elements/DropdownEl.vue'
import DatePickerIntervalEl from '@/components/elements/DatePickerIntervalEl.vue'
import SwitchEl from '@/components/elements/SwitchEl.vue'
import Table13El from '@/components/elements/Table13El.vue'
import ProfileEl from '@/components/elements/ProfileEl.vue'
import Profile2El from '@/components/elements/Profile2El.vue'
import DialNumberEl from '@/components/elements/DialNumberEl.vue'
import ElementNone from '@/components/elements/ElementNone.vue'
import CloseViewButtonEl from '@/components/elements/CloseViewButtonEl.vue'
import InputTextEl from '@/components/elements/InputTextEl.vue'
import CopyToClipboardEl from '@/components/elements/CopyToClipboardEl.vue'
import ListingItemEl from '@/components/elements/ListingItemEl.vue'
import NearStoresLinkEl from '@/components/elements/NearStoresLinkEl.vue'
import StoreListEl from '@/components/elements/StoreListEl.vue'
import ItemWorkingHoursEl from '@/components/elements/ItemWorkingHoursEl.vue'
import PinEl from '@/components/elements/PinEl.vue'
import MsisdnButtonsEl from '@/components/elements/MsisdnButtonsEl.vue'
import SmallMonthlyInvoiceSummaryEl from '@/components/elements/SmallMonthlyInvoiceSummaryEl.vue'
import YPaySummaryEl from '@/components/elements/YPaySummaryEl.vue'
import InstantSwitchEl from '@/components/elements/InstantSwitchEl.vue'
import InstantSwitch2RowEl from '@/components/elements/InstantSwitch2RowEl.vue'
import TitleWithIconEl from '@/components/elements/TitleWithIconEl.vue'
import Item2ColLinkEl from '@/components/elements/Item2ColLinkEl.vue'
import RadioButtonGroupEl from '@/components/elements/RadioButtonGroupEl.vue'
import Item2IconEl from '@/components/elements/Item2IconEl.vue'
import InfoMessageEl from '@/components/elements/InfoMessageEl.vue'
import AddOnCarouselEl2 from '@/components/elements/AddOnCarouselEl2.vue'
import LiteButtonEl from '@/components/elements/LiteButtonEl.vue'
import AccountBalanceDetailsLandlineEl from '@/components/elements/AccountBalanceDetailsLandlineEl.vue'
import YettelForYouEl from '@/components/elements/YettelForYouEl.vue'
import AccountPickerEl from '@/components/elements/AccountPickerEl.vue'
import CheckBoxGroupEl from '@/components/elements/CheckBoxGroupEl.vue'
import ConfirmationMessageEl from '@/components/elements/ConfirmationMessageEl.vue'
import DropdownGroupEl from '@/components/elements/DropdownGroupEl.vue'
import TimePickerEl from '@/components/elements/TimePickerEl.vue'
import MacAddressEl from '@/components/elements/MacAddressEl.vue'
import ItemPdfEl from '@/components/elements/ItemPdfEl.vue'
import WhatsNewEl from '@/components/elements/WhatsNewEl.vue'
import TabLinkEl from '@/components/elements/TabLinkEl.vue'
import Item2ColIconEl from '@/components/elements/Item2ColIconEl.vue'
import RangeSliderPickerEl from '@/components/elements/RangeSliderPickerEl.vue'
import ItemWithButtonEl from '@/components/elements/itemWithButtonEl.vue'
import Item2ColMultirowEl from '@/components/elements/Item2ColMultirowEl.vue'
import DayRangePickerEl from '@/components/elements/DayRangePickerEl.vue'
import DayRangeEl from '@/components/elements/DayRangeEl.vue'
import GifBannerEl from '@/components/elements/GifBannerEl.vue'
import SpamBannerEl from '@/components/elements/SpamBannerEl.vue'
import InstantDropdownEl from '@/components/elements/InstantDropdownEl.vue'
import CentralIconEl from '@/components/elements/CentralIconEl.vue'
import DarkModePickerEl from '@/components/elements/DarkModePickerEl.vue'
import HeaderCarouselEl from '@/components/elements/HeaderCarouselEl.vue'
import RoamingCountryPickerEl from '@/components/elements/RoamingCountryPickerEl.vue'
import Item2RowLinkEl from '@/components/elements/Item2RowLinkEl.vue'
import Item2LinksEl from '@/components/elements/Item2LinksEl.vue'
import AntrFileEl from '@/components/elements/AntrFileEl.vue'
import DescExpanderEl from '@/components/elements/DescExpanderEl.vue'
import RepairStatusEl from '@/components/elements/RepairStatusEl.vue'
import IconSubtitleEl from '@/components/elements/IconSubtitleEl.vue'
import ProfileInputEl from '@/components/elements/ProfileInputEl.vue'
import { ExtendedVue } from 'vue/types/vue'
import RoamingMultiCountryPickerEl from '@/components/elements/RoamingMultiCountryPickerEl.vue'
import AccountPicker2El from '@/components/elements/AccountPicker2El.vue'
import DatePickerInterval2El from '@/components/elements/DatePickerInterval2El.vue'
import LabelWithButton from '@/components/elements/LabelWithButtonEl.vue'
import TextWithStatus from '@/components/elements/TextWithStatusEl.vue'
import EmailInputEl from '@/components/elements/EmailInputEl.vue'
import Table31El from '@/components/elements/Table31El.vue'
import Item2ColText from '@/components/elements/Item2ColText.vue'
import block2TextEl from '@/components/elements/Block2TextEl.vue'
import Text4ListEl from '@/components/elements/text4List/Text4ListEl.vue'
import BlockStatusEl from '@/components/elements/BlockStatusEl.vue'
import Text3ListEl from '@/components/elements/text3list/Text3ListEl.vue'
import BlockWithLinkEl from '@/components/elements/BlockWithLinkEl.vue'
import Tab3LinkEl from '@/components/elements/Tab3LinkEl.vue'
import Carousel2El from '@/components/elements/Carousel2El.vue'
import BlueOfferEl from '@/components/elements/BlueOfferEl.vue'
import YellowOfferEl from '@/components/elements/YellowOfferEl.vue'
import LinkWithTextEl from '@/components/elements/LinkWithTextEl.vue'
import Item2ColFloatingIconEl from '@/components/elements/Item2ColFloatingIconEl.vue'
import ExpanderLikeEl from '@/components/elements/ExpanderLikeEl.vue'
import AntrfileIconEl from '@/components/elements/AntrfileIconEl.vue'
import BulletedTextEl from '@/components/elements/BulletedTextEl.vue'
import AntrfileWithLinkEl from '@/components/elements/AntrfileWithLinkEl.vue'
import ItemWithCopyEl from '@/components/elements/ItemWithCopyEl.vue'
import ConfirmationMessage2El from '@/components/elements/ConfirmationMessage2El.vue'
import BubbleBarEl from '@/components/elements/BubbleBarEl.vue'
import SoundEl from '@/components/elements/SoundEl.vue'
import BlockAntrfileEl from '@/components/elements/BlockAntrfileEl.vue'
import BlockStatus2El from '@/components/elements/BlockStatus2El.vue'
import SwitchWithButtonEl from '@/components/elements/SwitchWithButtonEl.vue'
import PlusLinkEl from '@/components/elements/PlusLinkEl.vue'
import BlockEl from '@/components/elements/BlockEl.vue'
import TableOnePlusTwoEl from '@/components/elements/TableOnePlusTwoEl.vue'
import TopupPickerEl from '@/components/elements/TopupPickerEl.vue'
import ContactPickerWithButtonEl from '@/components/elements/ContactPickerWithButtonEl.vue'
import TextWithInfoEl from '@/components/elements/TextWithInfoEl.vue'
import ProgressBarWithStripesEl from '@/components/elements/ProgressBarWithStripesEl.vue'
import ItemWithLinkEl from '@/components/elements/ItemWithLinkEl.vue'
import YSveBenefitStatus from '@/components/elements/YSveBenefitStatus.vue'
import YSveHeader from '@/components/elements/YSveHeader.vue'
import YSveLinkItem from '@/components/elements/YSveLinkItem.vue'
import YsveAntrfileEl from '@/components/elements/YsveAntrfileEl.vue'
import YSveSwitchWithButtonEl from '@/components/elements/YSveSwitchWithButtonEl.vue'
import YSveStatusItemEl from '@/components/elements/YSveStatusItemEl.vue'
import BlockChecklistEl from '@/components/elements/BlockChecklistEl.vue'
import LanguagePickerEl from '@/components/elements/LanguagePickerEl.vue'
import YSvePromoBlockEl from '@/components/elements/YSvePromoBlockEl.vue'
import YSveItemListEl from '@/components/elements/YSveItemListEl.vue'
import IconEl from '@/components/elements/IconEl.vue'
import YSveMobileBankStatusEl from '@/components/elements/YSveMobileBankStatusEl.vue'
import ProgressBarWithTextEl from '@/components/elements/ProgressBarWithTextEl.vue'

// eslint-disable-next-line
const elements: Record<string, ExtendedVue<any, any, any, any, any>> = {
  link: LinkEl,
  item2col: Item2ColEl,
  line: LineEl,
  title: TitleEl,
  text: TextEl,
  button: ButtonEl,
  progressBar: ProgressBarEl,
  bar: BarEl,
  infoMessage: InfoMessageEl,
  telenorForYou: TelenorForYouEl,
  telenorForYouNoPic: TelenorForYouEl,
  accountBalanceMoney: AccountBalanceMoneyEl,
  accountBalanceState: AccountBalanceStateEl,
  carousel: CarouselEl,
  accountBalanceDetails: AccountBalanceDetailsEl,
  addOnCarousel: AddOnCarouselEl2,
  addOnCarousel2: AddOnCarouselEl2,
  smallRowOffer: SmallRowOfferEl,
  nearStoresLink: NearStoresLinkEl,
  whiteButton: WhiteButtonEl,
  liteButton: LiteButtonEl,
  image: ImageEl,
  smallAddOn: SmallAddOnEl,
  smallMultiRowOffer: SmallMultiRowOfferEl,
  addOnStatus: AddOnStatusEl,
  smallMonthlyInvoice: SmallMonthlyInvoiceEl,
  checkbox: CheckboxEl,
  dropdown: DropdownEl,
  datePickerInterval: DatePickerIntervalEl,
  datePickerInterval2: DatePickerInterval2El,
  switch: SwitchEl,
  'table1+3': Table13El,
  'table1+1': Table13El,
  profile: ProfileEl,
  profileNoPic: ProfileEl,
  profile2: Profile2El,
  dialNumber: DialNumberEl,
  closeViewButton: CloseViewButtonEl,
  inputText: InputTextEl,
  inputNumeric: InputTextEl,
  contactPicker: InputTextEl,
  contactPickerWithButton: ContactPickerWithButtonEl,
  copyToClipboard: CopyToClipboardEl,
  listingItem: ListingItemEl,
  storeList: StoreListEl,
  itemWorkingHours: ItemWorkingHoursEl,
  pin: PinEl,
  smallMonthlyInvoiceSummary: SmallMonthlyInvoiceSummaryEl,
  YPaySummary: YPaySummaryEl,
  msisdnButtons: MsisdnButtonsEl,
  biometricSwitch: ElementNone,
  instantSwitch: InstantSwitchEl,
  instantSwitch2row: InstantSwitch2RowEl,
  titleWithIcon: TitleWithIconEl,
  item2ColLink: Item2ColLinkEl,
  radioButtonGroup: RadioButtonGroupEl,
  item2Icon: Item2IconEl,
  accountPicker: AccountPickerEl,
  accountPicker2: AccountPicker2El,
  accountBalanceDetailsLandline: AccountBalanceDetailsLandlineEl,
  yettelForYou: YettelForYouEl,
  confirmationMessage: ConfirmationMessageEl,
  timePicker: TimePickerEl,
  dropdownGroup: DropdownGroupEl,
  checkboxGroup: CheckBoxGroupEl,
  macAddress: MacAddressEl,
  itemPDF: ItemPdfEl,
  whatsNew: WhatsNewEl,
  tabLink: TabLinkEl,
  item2colIcon: Item2ColIconEl,
  rangeSliderPicker: RangeSliderPickerEl,
  item2colMultirow: Item2ColMultirowEl,
  itemWithButton: ItemWithButtonEl,
  darkModePicker: DarkModePickerEl,
  dayRangePicker: DayRangePickerEl,
  dayRange: DayRangeEl,
  gifBanner: GifBannerEl,
  instantDropdown: InstantDropdownEl,
  centralIcon: CentralIconEl,
  spamBanner: SpamBannerEl,
  headerCarousel: HeaderCarouselEl,
  roamingCountryPicker: RoamingCountryPickerEl,
  roamingMultiCountryPicker: RoamingMultiCountryPickerEl,
  item2rowLink: Item2RowLinkEl,
  item2Links: Item2LinksEl,
  antrfile: AntrFileEl,
  descExpander: DescExpanderEl,
  repairStatus: RepairStatusEl,
  iconSubtitle: IconSubtitleEl,
  profileInput: ProfileInputEl,
  labelWithButton: LabelWithButton,
  textWithStatus: TextWithStatus,
  emailInput: EmailInputEl,
  'table3+1link': Table31El,
  text4list: Text4ListEl,
  blockStatus: BlockStatusEl,
  item2ColText: Item2ColText,
  block2text: block2TextEl,
  text3list: Text3ListEl,
  blockWithLink: BlockWithLinkEl,
  tab3Link: Tab3LinkEl,
  headerCarousel2: Carousel2El,
  blueOffer: BlueOfferEl,
  yellowOffer: YellowOfferEl,
  linkWithText: LinkWithTextEl,
  item2colFloatingIcon: Item2ColFloatingIconEl,
  expanderLike: ExpanderLikeEl,
  antrfileIcon: AntrfileIconEl,
  bulletedText: BulletedTextEl,
  antrfileWithLink: AntrfileWithLinkEl,
  itemWithCopy: ItemWithCopyEl,
  confirmationMessage2: ConfirmationMessage2El,
  bubbleBar: BubbleBarEl,
  sound: SoundEl,
  blockAntrfile: BlockAntrfileEl,
  blockStatus2: BlockStatus2El,
  switchWithButton: SwitchWithButtonEl,
  plusLink: PlusLinkEl,
  block: BlockEl,
  'table1+2': TableOnePlusTwoEl,
  topupPicker: TopupPickerEl,
  itemWithLink: ItemWithLinkEl,
  ySveSwitchWithButton: YSveSwitchWithButtonEl,
  ySveBenefitStatus: YSveBenefitStatus,
  ySveHeader: YSveHeader,
  ySveStatusItem: YSveStatusItemEl,
  progressBarWithStripes: ProgressBarWithStripesEl,
  textWithInfo: TextWithInfoEl,
  ySveLinkItem: YSveLinkItem,
  languagePicker: LanguagePickerEl,
  blockChecklist: BlockChecklistEl,
  ySvePromoBlock: YSvePromoBlockEl,
  ySveItemList: YSveItemListEl,
  icon: IconEl,
  ySveMobileBankStatus: YSveMobileBankStatusEl,
  progressBarWithText: ProgressBarWithTextEl,
  ySveAntrfile: YsveAntrfileEl
}

export default Object.freeze(elements)
